module.exports = __webpack_public_path__ + "img/Icon Board Members.de26e236.svg";